export const NO_AGENCY_LABEL = 'Без АН';
export function groupAgentsByAgency(agents) {
    const byAgency = new Map();
    for (const agent of agents) {
        const key = agent.agencyName?.trim() || NO_AGENCY_LABEL;
        const list = byAgency.get(key);
        if (list)
            list.push(agent);
        else
            byAgency.set(key, [agent]);
    }
    return [...byAgency.entries()]
        .map(([agencyName, groupAgents]) => ({
        agencyName,
        agents: [...groupAgents].sort((a, b) => (a.displayName || '').localeCompare(b.displayName || '', 'ru')),
    }))
        .sort((a, b) => {
        if (a.agencyName === NO_AGENCY_LABEL)
            return 1;
        if (b.agencyName === NO_AGENCY_LABEL)
            return -1;
        return a.agencyName.localeCompare(b.agencyName, 'ru');
    });
}
export function buildFunnelExportRows(agents, options = {}) {
    return agents.map((agent) => ({
        displayName: agent.displayName || 'Без имени',
        bitrixId: agent.realtorId,
        agentId: agent.agentId ?? '',
        phone: agent.phones.join(', '),
        agencyName: agent.agencyName?.trim() || NO_AGENCY_LABEL,
        ...(options.includeProfileCompleteness
            ? {
                profileCompleteness: agent.profileCompleteness ?? agent.yBucket ?? '',
            }
            : {}),
        ...(options.includeSocialCompleteness
            ? {
                socialCompleteness: agent.socialCompleteness ?? agent.yBucket ?? '',
                socialNetworks: agent.socialNetworksPresent?.join(', ') ?? '',
            }
            : {}),
        ...(options.includeSmartisCaptured
            ? {
                smartisCaptured: agent.smartisCaptured == null
                    ? ''
                    : agent.smartisCaptured
                        ? 'Да'
                        : 'Нет',
            }
            : {}),
        ...(options.includeTgBotAvailable
            ? {
                tgBotAvailable: agent.tgBotAvailable == null
                    ? ''
                    : agent.tgBotAvailable
                        ? 'Да'
                        : 'Нет',
            }
            : {}),
        ...(options.includeUnitySources
            ? {
                unitySourcesPercent: agent.unitySourcesPercent ?? '',
            }
            : {}),
    }));
}
